import moment from 'moment';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { CalendarIcon2, DeleteIcon, EditIcon } from '../../../assets/icons';
import { ExternalBooking } from '../../../redux/types/integrationTypes';
import { ButtonType, ModalWindowTypes } from '../../../utils/@globalTypes';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { getBookingIcon } from '../functions';
import Button from '../../Button';
import ColorBannerPaid from '../ColorBannerPaid';
import styles from '../ListItem/ListItem.module.scss';
import detailsStyles from './ExternalBookingListItem.module.scss';

type Props = {
  booking: ExternalBooking;
  objectName?: string;
};

const ExternalBookingListItem = ({ booking, objectName }: Props) => {
  const dispatch = useDispatch();
  const source = booking.source_type === 'ical' ? 'iCalendar' : 'Менеджер каналов';
  const syncStatus = booking.sync_status === 'cancelled'
    ? 'Отменена во внешнем источнике'
    : booking.sync_status === 'conflict'
      ? 'Конфликт синхронизации'
      : 'Синхронизируется';

  const openBooking = () => dispatch(setModalWindowData({
    type: ModalWindowTypes.SHOW_EXTERNAL_RESERVATION,
    data: { id: booking.id },
  }));
  const openChessboard = () => {
    localStorage.setItem('chess', booking.check_in_date);
  };

  return (
    <div className={classNames(styles.container, { [styles.notViewed]: !booking.viewed })}>
      <div
        className={styles.left}
        role="button"
        tabIndex={0}
        onClick={openBooking}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openBooking();
          }
        }}
        aria-label={`Внешняя бронь ${source}, ${objectName || 'объект'}, ${booking.check_in_date}`}
      >
        <div className={styles.info}>
          <div className={styles.objectBlock}>
            <div className={styles.icon}>{getBookingIcon(booking.booking_status)}</div>
            <div className={styles.rent}>{objectName || 'Объект не указан'}</div>
          </div>

          <div className={styles.personBlock}>
            <div className={styles.names}>
              <div className={detailsStyles.bookingDetails}>
                <span className={styles.last_name}>Внешняя бронь</span>
                <span className={detailsStyles.source}>
                  {source}
                </span>
              </div>
            </div>
            <div className={styles.dates}>
              <div className={styles.dates_left}>
                <CalendarIcon2 />
                <span className={styles.date}>
                  {moment(booking.check_in_date).format('DD.MM.YYYY')}
                </span>
              </div>
              <div className={styles.dates_right}>
                {' '}&mdash;{' '}
                <span className={styles.date}>
                  {moment(booking.check_out_date).format('DD.MM.YYYY')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <ColorBannerPaid
          status={booking.sync_status === 'cancelled' ? 'cld' : booking.booking_status}
          check_out_date={booking.check_out_date}
          showAmounts={false}
          subtitle={booking.sync_status === 'cancelled' ? 'Во внешнем источнике' : syncStatus}
        />
      </div>

      <div className={styles.right}>
        <Button
          type={ButtonType.SMALL}
          title={<EditIcon />}
          onClick={openBooking}
        />
        <div onClick={openChessboard}>
          <Button
            type={ButtonType.SMALL}
            title={<CalendarIcon2 fill="#8692A6" width="26" height="26" />}
            wrapperClassName="bookingList"
            isStrokeIcon
            path="/checkerboard"
          />
        </div>
        <Button
          type={ButtonType.SMALL}
          title={<DeleteIcon />}
          className="deleteBookingList"
          wrapperClassName="bookingList"
          disabled
        />
      </div>
    </div>
  );
};

export default ExternalBookingListItem;
